module.exports = require("@seddi/math-v2");